import SharedNavbar from '@/components/feature/SharedNavbar';
import { Seo } from '@/components/Seo';
import SharedFooter from '@/components/feature/SharedFooter';
import HeroBanner from './components/HeroBanner';
import PhilosophySection from './components/PhilosophySection';
import StepPrepSection from './components/StepPrepSection';
import StepTreatSection from './components/StepTreatSection';
import StepProtectSection from './components/StepProtectSection';
import ClimateTipsSection from './components/ClimateTipsSection';
import ResultsTimelineSection from './components/ResultsTimelineSection';
import FaqAccordionSection from './components/FaqAccordionSection';
import StepCTA from './components/StepCTA';
import ThreeStepStickyBar from './components/ThreeStepStickyBar';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import SetPageV2 from './SetPageV2';

export default function ThreeStepTreatmentPage() {
  const { isNew } = useSiteDesign();
  if (isNew)
    return (
      <main className="w-full min-h-screen bg-white">
        <Seo pageKey="threeStep" />
        <SharedNavbar />
        <SetPageV2 />
        <SharedFooter />
      </main>
    );
  return (
    <>
      <main className="w-full min-h-screen bg-white font-sans">
        <Seo pageKey="threeStep" />
        <SharedNavbar />
        <HeroBanner />
        <PhilosophySection />
        <StepPrepSection />
        <StepTreatSection />
        <StepProtectSection />
        <ClimateTipsSection />
        <ResultsTimelineSection />
        <FaqAccordionSection />
        <StepCTA />
        <SharedFooter />
      </main>
      <ThreeStepStickyBar />
    </>
  );
}
